<template>
<div>
    <!-- <p class="tasks">Completed Tasks: {{todos.filter(todo => {return todo.done === true}).length}}</p>
    <p class="tasks">Pending Tasks: {{todos.filter(todo => {return todo.done === false}).length}}</p> -->
    <student-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-on:view-submissions="viewSubmissions" v-for="(data,index) in studentList" :data="data" v-bind:key="data.key" :dataIndex="index"></student-view>
</div>
</template>

<script>
import StudentView from './StudentView';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            input: {
                level: '',
                name: '',
                kelasID: ""
            },
            result: "",
        };
    },
    props: ['studentList','kelasID','className'],
    components: {
        StudentView,
    },
    methods: {
        deleteData(data) {            
            
            // Use sweetalert2
            this.$swal({
                title: "Are you sure? ",
                text: data.firstName + ' ' + data.lastName + " will be permanently deleted, and ALL POINTS awarded to this student will be REMOVED. To continue, enter 'DELETE USER' in the text field below and press OK",
                input: 'text',
                showCancelButton: true,
                inputValidator: (value) => {
                    if (value == "DELETE USER"){

                        axios.defaults.responseType = 'json'
                        axios.post(process.env.NEW_ENDPOINT + '/students/remove/', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            _id: data._id,
                        })
                        .then(response => {
                            self.isLoading = false;
                            if (response.data.success == false) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
                                const dataIndex = this.studentList.indexOf(data);
                                this.studentList.splice(dataIndex, 1);
                            }
                        })
                        .catch(e => {
                            self.isLoading = false;
                            console.log(e.response)
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })

                    }else{
                        Toast.open({
                            message: "You entered the wrong input. User is not removed.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                    }
                    //return !value && 'You need to write something!'
                }
            });
            
        },
        viewSubmissions(data) {
            console.log("98 kelasID: " + this.kelasID)
            console.log("98 className: " + this.className)
            console.log(data)            
            
            this.$store.commit('UPDATE_CLASSES_DASHBOARD_SINGLE_ID',this.kelasID)
            this.$store.commit('UPDATE_CLASSES_DASHBOARD_SINGLE_NAME',this.className)
            this.$store.commit('UPDATE_STUDENT_ID',data._id)
            this.$store.commit('UPDATE_STUDENT_NAME',data.firstName + " " + data.lastName)
            localStorage.setItem('CLASSES_DASHBOARD_SINGLE_ID',this.kelasID)
            localStorage.setItem('CLASSES_DASHBOARD_SINGLE_NAME',this.className)
            localStorage.setItem('STUDENT_ID',data._id)
            localStorage.setItem('STUDENT_NAME',data.firstName + " " + data.lastName)

            this.$router.push({
                name: "ManageStudentsSubmissions"
            });
        },
        updateData(data) {
            if (data.firstName != null && data.firstName.length > 0)  {
                this.input._id = data._id
                this.input.kelasID = data.kelasID.trim()
                this.input.firstName = data.firstName.trim()

                this.input.lastName = data.lastName;
                if (this.input.lastName){
                    this.input.lastName = this.input.lastName.trim()
                }

                this.input.father = data.father;
                if (this.input.father){
                    this.input.father = this.input.father.trim()
                }

                this.input.fatherID = data.fatherID
                if (this.input.fatherID){
                    this.input.fatherID = this.input.fatherID.trim()
                }

                this.input.fatherEmail = data.fatherEmail
                if (this.input.fatherEmail){
                    this.input.fatherEmail = this.input.fatherEmail.trim()
                }

                this.input.mother = data.mother
                if (this.input.mother){
                    this.input.mother = this.input.mother.trim()
                }

                this.input.motherID = data.motherID
                if (this.input.motherID){
                    this.input.motherID = this.input.motherID.trim()
                }

                this.input.motherEmail = data.motherEmail
                if (this.input.motherEmail){
                    this.input.motherEmail = this.input.motherEmail.trim()
                }

                this.input.contactNo1 = data.contactNo1
                if (this.input.contactNo1){
                    this.input.contactNo1 = this.input.contactNo1.trim()
                }

                if (this.input.fatherID != null){
                    if (this.input.fatherID.length > 0){
                        this.input.fatherID = this.input.fatherID.replace(/[^A-Z0-9]/ig, "");
                    }
                }

                if (this.input.motherID != null){
                    if (this.input.motherID.length > 0){
                        this.input.motherID = this.input.motherID.replace(/[^A-Z0-9]/ig, "");
                    }
                }

                axios.defaults.responseType = 'json'
                axios.post(process.env.NEW_ENDPOINT + '/students/update/', {
                    token: localStorage.getItem('jwtTokenV2'),
                    email: localStorage.getItem('email'),
                    _id: data._id,
                    firstName: this.input.firstName,
                    lastName: this.input.lastName,
                    father: this.input.father,
                    fatherID: this.input.fatherID,                
                    fatherEmail: this.input.fatherEmail,
                    mother: this.input.mother,            
                    motherID: this.input.motherID,            
                    motherEmail: this.input.motherEmail,
                    contactNo1: this.input.contactNo1
                })
                .then(response => {
                    self.isLoading = false;
                    if (response.data.success == false) {
                        Toast.open({
                            message: response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            message: response.data.msg,
                            type: 'is-success',
                            duration: 3000
                        })
                    }

                    this.input.firstName = '';
                    this.input.lastName = '';
                    this.input.father = '';
                    this.input.fatherID = '';
                    this.input.fatherEmail = '';
                    this.input.mother = '';
                    this.input.motherID = '';
                    this.input.motherEmail = '';
                    this.input.contactNo1 = '';
                    this.input.isCreating = false;
                    // this.$parent.getStudentsInThisClass()
                })
                .catch(e => {
                    self.isLoading = false;
                    console.log(e.response)
                    if (e.response.status === 401) {                            
                        Toast.open({
                            message: "Unauthorized access. Please re-login.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            message: 'Error: ' + e.response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }
                })

            } else {
                Toast.open({
                    message: "Please at least enter the student's/user's first name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
        },
    },
};
</script>

<style scoped>
p.tasks {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Students/StudentList.vue